export default __webpack_public_path__ + "static/media/dog_cat.9a02ffb8.jpg";